import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createCustomerEventsBackfill = unaryRpc({
  name: "createCustomerEventsBackfill",
  input: z.object({
    teamId: zExt.objectId(),
    batchSize: z.number().optional(),
  }),
  output: z.object({ workflowId: z.string() }),
});
